import decomposeCheckboxesToBitwise from './decomposeCheckboxesToBitwise';

const decomposeCheckboxesToBitwiseArray = ({ formattedValue }, currentValues = {}) =>
  decomposeCheckboxesToBitwise(formattedValue, currentValues);

export default decomposeCheckboxesToBitwiseArray;
